"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Message;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _styles = require("./styles");
var _utils = require("../../../lib/utils");
function Message(_ref) {
  let {
    provider
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.MessageContainer, {
    "data-testid": "ApptSummary__Heading"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.apptSummaryMessage, {
    values: {
      display_name: (0, _utils.formatProviderName)(provider)
    }
  })));
}
Message.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Message"
};